import { IBookingCalendarStore } from '../../index'
import { IToggleServicesModalLoading } from '../../../../actions/bookingCalendar/reservationModal/toggleServicesModal'

export default function(
  state: IBookingCalendarStore,
  action: IToggleServicesModalLoading,
): IBookingCalendarStore {
  return {
    ...state,
    reservationModal: {
      ...state.reservationModal,
      servicesModal: {
        ...state.reservationModal.servicesModal,
        isLoading: action.toggle,
      },
    },
  }
}
